import { nextTick } from 'process'
import CommonConstans from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import { Component, Vue } from 'vue-property-decorator'
import CACG1080Service from './CACG1080Service'
import CACG1060ParamModel from '../CACG1060/CACG1060ParamModel'
import CACG1070ParamModel from '../CACG1070/CACG1070ParamModel'
import CACG1080ViewModel from './CACG1080ViewModel'
import TransportService from '@/common/TransportService'
import CommonConstants from '@/common/CommonConstants'
import CommonUtil from '@/common/utils/CommonUtil'
import { fixedContent } from '@/assets/js/main.js'

@Component({
  name: 'CACG1080',
  components: {}
  })
export default class CACG1080Controller extends Vue {
  private isCompleteLoading = false
  private SCALE_VALUE = 6
  private DEFAULT_YEAR_SELECTED = 0
  private cacg1080Service = new CACG1080Service()
  private isShowChart = false
  private cacg1080ViewModel: CACG1080ViewModel = {
    productNameInformal: '',
    investTrustProductOneYearDailyLst: [
      {
        critValCritD: '',
        critVal: null,
        asset: null
      }
    ],
    investTrustProductTenYearMonthlyLst: [
      {
        critValCritYM: '',
        critVal: null,
        asset: null
      }
    ],
    productDivName: '',
    productNo: '',
    shhnCd: '',
    dataChartLineOneYearDaily: [],
    dataChartColumnOneYearDaily: [],
    dataChartLineTenYearMonthly: [],
    dataChartColumnTenYearMonthly: [],
    yearText: '1年'
  }

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    nextTick(() => {
      fixedContent()
    })
    if (this.isShowChart) {
      window.addEventListener('orientationchange', this.refreshPage);
    }
  }

  beforeDestroy() {
    window.removeEventListener('orientationchange', this.refreshPage);
  }

  private refreshPage() {
    location.reload();
  }

  /**
   * 初期処理
   */
  private async init() {
    const productNo = JSON.parse(
      JSON.stringify(this.$route.query.productNo || '')
    )
    const shhnCd = JSON.parse(JSON.stringify(this.$route.query.shhnCd || ''))

    this.cacg1080ViewModel.productNo = productNo
    this.cacg1080ViewModel.shhnCd = shhnCd
    const params = `shhnCd=${this.cacg1080ViewModel.shhnCd}`
    const [
      caca1080ResponeModel,
      transportResponseModel
    ] = await Promise.all([
      this.cacg1080Service.callAPICACA1080(
        productNo,
        shhnCd
      ),
      // 稼働／閲覧統計ログを実行する
      TransportService.callAPITransportWithLogMode(CommonConstants.URL_CACG1080, null, params, CommonConstants.LOG_MODE_ACCESS_ONLY)
    ])

    if (caca1080ResponeModel.redirectRiv === 7) {
      const messageError = caca1080ResponeModel?.common?.errors
      messageError.forEach((item) => {
        Object.assign(item, { url: '' })
      })

      SessionStorageService.setItem(
        CommonConstans.MESSAGE_ERROR,
        JSON.stringify(messageError)
      )

      this.$router.push({ name: 'cacg0070' })
    }

    this.isShowChart =
      CommonUtil.isNotNullArray(
        caca1080ResponeModel.investTrustProductOneYearDailyLst,
        ['asset', 'critVal']
      ) ||
      CommonUtil.isNotNullArray(
        caca1080ResponeModel.investTrustProductTenYearMonthlyLst,
        ['asset', 'critVal']
      )

    if (caca1080ResponeModel.investTrustProductOneYearDailyLst) {
      this.cacg1080ViewModel.investTrustProductOneYearDailyLst =
        caca1080ResponeModel.investTrustProductOneYearDailyLst
    } else {
      this.cacg1080ViewModel.investTrustProductOneYearDailyLst = null
    }

    if (caca1080ResponeModel.investTrustProductTenYearMonthlyLst) {
      this.cacg1080ViewModel.investTrustProductTenYearMonthlyLst =
        caca1080ResponeModel.investTrustProductTenYearMonthlyLst
    } else {
      this.cacg1080ViewModel.investTrustProductTenYearMonthlyLst = null
    }

    this.cacg1080ViewModel.productDivName = caca1080ResponeModel.productDivName
    this.cacg1080ViewModel.productNameInformal =
      caca1080ResponeModel.productNameInformal

    const dataOneYear = this.cacg1080Service.formatDataChartOneYear(
      this.cacg1080ViewModel
    )

    this.cacg1080ViewModel.dataChartLineOneYearDaily = dataOneYear[0]
    this.cacg1080ViewModel.dataChartColumnOneYearDaily = dataOneYear[1]

    const dataTenYear = this.cacg1080Service.formatDataChartTenYear(
      this.cacg1080ViewModel
    )

    this.cacg1080ViewModel.dataChartLineTenYearMonthly = dataTenYear[0]
    this.cacg1080ViewModel.dataChartColumnTenYearMonthly = dataTenYear[1]
    this.isCompleteLoading = true
  }

  /**
   * 基準価額（CACG1060）画面に遷移する。
   */
  private gotoCACG1060() {
    const cacg1060ParamModel: CACG1060ParamModel = {
      productNo: this.cacg1080ViewModel.productNo,
      shhnCd: this.cacg1080ViewModel.shhnCd
    }

    this.$router.push({ name: 'cacg1060', query: cacg1060ParamModel })
  }

  /**
   * 資料一覧（CACG1070）画面に遷移する。
   */
  private gotoCACG1070() {
    const cacg1070ParamModel: CACG1070ParamModel = {
      productNo: this.cacg1080ViewModel.productNo,
      shhnCd: this.cacg1080ViewModel.shhnCd
    }

    this.$router.push({ name: 'cacg1070', query: cacg1070ParamModel })
  }

  /**
   * 運用商品一覧（CACG1010）画面に遷移する。
   */
  private gotoCACG1010() {
    this.$router.push({ name: 'cacg1010' })
  }

  /**
   * 資産残高の推移ボタン押下
   * @param yearNum
   */
  public async clickChangeYear(yearNum) {
    this.cacg1080ViewModel.yearText = yearNum + '年'
  }
}
